module.exports = __webpack_public_path__ + "img/LQS Analyser.2c46bd03.svg";